/**
 * AG Grid Enterprise License Configuration
 * See: https://ag-grid.com/vue-data-grid/license-install/
 */

import { LicenseManager } from 'ag-grid-enterprise';

// Set license key from environment variable if available
// You can get your license key from: https://ag-grid.com/vue-data-grid/license-install/
const licenseKey = process.env.VUE_APP_AG_GRID_LICENSE_KEY;

if (licenseKey) {
	LicenseManager.setLicenseKey(licenseKey);
} else if (process.env.NODE_ENV === 'production') {
	console.warn(
		'AG Grid Enterprise license key not found. ' +
		'Set VUE_APP_AG_GRID_LICENSE_KEY in your environment variables. ' +
		'Enterprise features may not work in production.'
	);
}

